import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchLeaderboard } from '../services/leaderboardService';
import type { LeaderboardEntry, LeaderboardPeriod } from '@beast-keeper/shared';
import { TITLES } from '@beast-keeper/shared';

export default function LeaderboardScreen() {
  const navigate = useNavigate();
  const [period, setPeriod] = useState<LeaderboardPeriod>('all');
  const [entries, setEntries] = useState<LeaderboardEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchLeaderboard(period)
      .then((data) => setEntries(data.entries))
      .catch(() => setEntries([]))
      .finally(() => setLoading(false));
  }, [period]);

  const tabs: { key: LeaderboardPeriod; label: string }[] = [
    { key: 'all', label: '总榜' },
    { key: 'week', label: '本周' },
    { key: 'today', label: '今日' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, padding: 'var(--space-lg) var(--space-md)' }}>
      <div className="top-bar">
        <button className="btn-back" onClick={() => navigate('/')} aria-label="返回首页">←</button>
        <div className="title">🏆 饲养员天梯</div>
      </div>

      {/* Tabs */}
      <div className="lb-tabs">
        {tabs.map((t) => (
          <button
            key={t.key}
            className={`lb-tab${period === t.key ? ' active' : ''}`}
            onClick={() => setPeriod(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* List */}
      <div className="scroll-area">
        {loading ? (
          <div className="lb-empty">加载中...</div>
        ) : entries.length === 0 ? (
          <div className="lb-empty">
            还没有饲养员上榜<br />赶紧成为第一人，名垂奶粉史！🍼
          </div>
        ) : (
          <div className="lb-list">
            {entries.map((e, i) => {
              const medals = ['🥇', '🥈', '🥉'];
              const isPodium = e.rank <= 3;
              const rankStr = isPodium ? medals[e.rank - 1] : String(e.rank);

              return (
                <div key={i} className={`lb-item${e.isMe ? ' me' : ''}`}>
                  <span className={`lb-rank${isPodium ? ' podium' : ''}`}>{rankStr}</span>
                  <span className="lb-icon">{e.icon}</span>
                  <span className="lb-name">{e.nickname}</span>
                  <span className="lb-title-badge">{e.title}</span>
                  <span className="lb-score">{e.score}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
